import React from 'react';
import { InlineIcon } from '../../../../../../inline-icon/inline-icon';
import styles from '../../card.scss';
import ArrowRightLongIcon from '../../../../../../../icons/compiled/components/ArrowRightLongIcon';
export class ProductCardContent extends React.Component {
  renderThumbnail() {
    const {
      cardData
    } = this.props;
    const {
      thumbnailUrl
    } = cardData;
    if (!thumbnailUrl) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles.thumbnail
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.image,
      style: {
        backgroundImage: `url(${thumbnailUrl})`
      }
    }));
  }
  renderText() {
    const {
      cardData
    } = this.props;
    const {
      text
    } = cardData;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.text
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['text-content'],
      "data-hook": "action-card-title"
    }, text));
  }
  renderCta() {
    const {
      cardData
    } = this.props;
    const {
      buttonLabel
    } = cardData;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.cta
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['cta-label'],
      "data-hook": "action-card-action-text"
    }, buttonLabel), /*#__PURE__*/React.createElement("span", {
      className: styles['cta-icon-container']
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(ArrowRightLongIcon, null),
      className: styles['icon-arrow']
    })));
  }
  render() {
    const {
      className,
      isAriaHidden
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      "aria-hidden": isAriaHidden
    }, this.renderThumbnail(), /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, this.renderText(), this.renderCta()));
  }
}
//# sourceMappingURL=card-content.js.map